module.exports = __webpack_public_path__ + "img/6_heart.30ed0a0a.jpg";